const styles = (theme) => ({
  "@global": {
    "@keyframes pulse": {
      "0%, 100%": { opacity: 1 },
      "50%": { opacity: 0.55 },
    },
    "@keyframes gradient": {
      "0%": { backgroundPosition: "0% 50%" },
      "50%": { backgroundPosition: "100% 50%" },
      "100%": { backgroundPosition: "0% 50%" },
    },
  },
  root: {
    flexGrow: 1,
    backgroundColor: "#E9ECEF",
    minHeight: "100vh",
  },
  headerBlock: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    height: "auto",
    padding: theme.spacing(3),
    marginBottom: 0,
    borderRadius: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
    "& .MuiTextField-root": {
      "& .MuiOutlinedInput-root": {
        backgroundColor: "#F8FAFC",
        borderRadius: theme.spacing(1.5),
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "#F1F5F9",
        },
        "&.Mui-focused": {
          backgroundColor: "#F8FAFC",
          "& fieldset": {
            borderColor: theme.palette.primary.main,
            borderWidth: "2px",
          },
        },
      },
      "& .MuiInputLabel-root": {
        color: "#64748B",
        "&.Mui-focused": {
          color: theme.palette.primary.main,
        },
      },
      "& .MuiOutlinedInput-input": {
        color: "#1E293B",
        "&::placeholder": {
          color: "#94A3B8",
          opacity: 1,
        },
      },
    },
  },
  appBar: {
    backgroundColor: theme.palette.darkGrey.main,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  formContainer: {
    paddingTop: "30px",
    paddingBottom: "30px",
    width: "100%",
  },
  form: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "20ch",
    },
  },
  imageArRecognition: {
    borderRadius: 8,
    height: "150px",
    objectFit: "contain",
    backgroundColor: "#E5E8EB",
    [theme.breakpoints.up("md")]: {
      height: "300px",
    },
  },
  imageCardVintage: {
    marginLeft: 10,
    width: 411 / 3,
    height: "auto",
    minHeight: 482 / 3,
    marginTop: 0,
    [theme.breakpoints.up("md")]: {
      width: 411 / 2,
      minHeight: 482 / 2,
    },
  },
  imageCardVintageTab: {
    marginLeft: 10,
    width: 1024 / 8,
    height: "auto",
    minHeight: 998 / 8,
    marginTop: 0,
    [theme.breakpoints.up("md")]: {
      width: 1024 / 4,
      minHeight: 998 / 4,
    },
  },
  imageCardClue: {
    marginLeft: 10,
    width: 410 / 3,
    height: 700 / 3,
    marginTop: 0,
    [theme.breakpoints.up("md")]: {
      width: 410 / 2,
      height: 700 / 2,
    },
  },
  imageCardClueTab: {
    marginLeft: 10,
    width: 1152 / 8,
    height: 998 / 8,
    marginTop: 0,
    [theme.breakpoints.up("md")]: {
      width: 1152 / 4,
      height: 998 / 4,
    },
  },
  imageCardMedia: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
    backgroundColor: "#E5E8EB",
  },
  imageInfos: {
    paddingTop: 18,
    paddingLeft: 8,
    color: "#494949ff",
    fontSize: 12,
    fontWeight: 600,
  },
  uploadFile: {
    marginTop: 0,
    marginLeft: 0,
    maxWidth: 300,
    fontWeight: 700,
    fontSize: 12,
  },
  addRowButton: {
    marginTop: 10,
    marginLeft: 10,
    maxWidth: 250,
    fontWeight: 500,
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  beta: {
    marginTop: 0,
    marginLeft: 0,
    letterSpacing: "0.04em",
    lineHeight: 1.4,
    display: "inline-block",
    backgroundColor: "#ffcc00" /* Couleur de fond jaune */,
    color: "#fff" /* Couleur du texte blanc */,
    padding: "4px 8px" /* Espacement intérieur */,
    fontSize: "15px" /* Taille de la police */,
    fontWeight: "bold" /* Texte en gras */,
    borderRadius: "4px" /* Coins arrondis */,
    textTransform: "uppercase" /* Texte en majuscules */,
    boxShadow: "none",
  },
  enigmasButtons: {
    margin: theme.spacing(1),
  },
  textfieldResponses: {
    width: "100%",
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      minWidth: "0 !important",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#FFFFFF",
      borderRadius: theme.spacing(1.5),
      "&:hover": {
        backgroundColor: "#F8FAFC",
      },
      "&.Mui-focused": {
        backgroundColor: "#FFFFFF",
      },
    },
  },
  textfieldPropositions: {
    minWidth: "200px",
    backgroundColor: "white",
    [theme.breakpoints.up("sm")]: {
      minWidth: "250px",
    },
    [theme.breakpoints.up("md")]: {
      minWidth: "300px",
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: "350px",
    },
  },
  textfieldValue: {
    maxWidth: "60px",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "100px",
    },
    backgroundColor: "white",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: "50%",
    backgroundColor: "white",
    padding: 6,
    borderRadius: 8,
    border: "1px solid #c0c0c0",

    maxWidth: 200,
    [theme.breakpoints.up("sm")]: {
      maxWidth: 250,
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: 500,
    },
  },
  helperText: {
    color: "#64748B",
    fontSize: "0.875rem",
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0),
  },
  helperTextSmall: {
    fontSize: 14,
    fontWeight: 100,
    marginLeft: 8,
  },
  textFieldBig: {
    minWidth: "90%",
    backgroundColor: "white",
    borderRadius: 8,
  },
  returnButtonLink: {
    textDecoration: "none",
  },
  imageDimensionsText: {
    paddingLeft: 8,
    color: "#494949ff",
    fontSize: 12,
  },
  saveButton: {
    backgroundColor: theme.palette.orange.main,
    color: theme.palette.darkGrey.main,
    fontSize: 15,
    fontWeight: 700,
    borderWidth: "0px",
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },

  textFieldContainer: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 8,
    padding: 18,
    width: "80%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 12,
  },
  textFieldContainerLight: {
    backgroundColor: "transparent",
    borderRadius: 8,
    padding: 0,
    width: "80%",
    display: "flex",
    flexDirection: "column",
    marginBottom: 12,
  },
  headerTextFieldDark: {
    color: "black",
    borderRadius: 5,
    fontWeight: 800,
  },
  headerTextField: {
    color: "white",
    borderRadius: 5,
    fontWeight: 700,
  },
  textField: {
    width: "100%",
    marginBottom: theme.spacing(2),
    "& .MuiOutlinedInput-root": {
      width: "100%",
      borderRadius: theme.spacing(1.5),
      "& textarea": {
        minHeight: "150px",
        fontSize: "16px",
        lineHeight: "1.5",
        padding: theme.spacing(2),
        [theme.breakpoints.up("md")]: {
          fontSize: "18px",
        },
      },
    },
  },
  addSpace: {
    height: "210px",
  },
  boxOptional: {
    borderRadius: 12,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    paddingTop: 12,
    paddingBottom: 16,
    // minHeight: 600,
  },
  boxOptionalRight: {
    minHeight: 200,
    backgroundColor: "#DCE0EC",
    borderRadius: 12,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 12,
    paddingBottom: 16,
    width: "100%",
  },
  rightContainerTopOverflow: {
    paddingTop: 65,
    paddingBottom: 64,
  },
  spaceBetweenGrids: {
    height: 20,
  },
  warningBeta: {
    padding: 8,
    borderRadius: 8,
    fontWeight: 200,
    fontSize: 15,
    marginRight: 12,
    color: "#cf4a4a",
    textAlign: "center",
  },
  primaryOptionalTitle: {
    marginTop: -20,
    marginLeft: 12,
    padding: "6px 14px",
    width: "fit-content",
    borderRadius: 8,
    fontWeight: 800,
    fontSize: 18,
    color: "#48506B",
    backgroundColor: "white",
    boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.15)",
  },
  optionalTitle: {
    marginTop: 0,
    padding: 0,
    fontWeight: 600,
    fontSize: 15,
    color: "#262936",
    // backgroundColor: "white",
    // boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.15)",
  },
  orTitle: {
    marginLeft: -10,
    marginTop: 12,
    padding: 8,
    margin: 12,
    borderRadius: "50%",
    fontWeight: 800,
    fontSize: 15,
    color: "#48506B",
    backgroundColor: "white",
    boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.45)",
  },
  hrVertical: {
    borderLeft: "1px solid #C1C6D3",
    height: "650px",
    flexShrink: 0, // Empêche l'élément de s'étendre
    marginRight: -10,
    width: 1,
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "inline",
    },
  },
  hrVerticalOtherBox: {
    borderLeft: "1px solid #C1C6D3",
    height: "650px",
    flex: 1,
    padding: 12,
    marginRight: -10,
  },
  headerLocations: {
    fontSize: 12,
    fontWeight: 800,
    marginLeft: 12,
  },
  filename: {
    marginTop: 6,
    fontSize: 12,
    fontWeight: 400,
  },
  textfieldWhite: {
    backgroundColor: "white",
  },
  mapButton: {
    backgroundColor: theme.palette.orange.main,
    color: "#ffffff",
    fontSize: 10,
    borderRadius: 8,
    height: 40,
    marginTop: 9,
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
    },
  },
  banner: {
    backgroundColor: "#B85A00",
    textAlign: "center",
    fontSize: 16,
    fontWeight: 900,
    padding: "15px",
    color: "white",
    margin: "16px",
    borderRadius: "8px",
    // marginBottom: "10px",
  },
  alignCenterSm: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      justifyContent: "start",
      alignItems: "start",
    },
  },
  buttonDisabled: {
    backgroundColor: "#CBD5E1",
    color: "#475569",
    cursor: "not-allowed",
    "&:hover": {
      backgroundColor: "#CBD5E1",
    },
  },
  enigmaText: {
    fontSize: "16px",
    fontWeight: 500,
    color: theme.palette.text.primary,
    [theme.breakpoints.up("md")]: {
      fontSize: "18px",
    },
  },
  pointsTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#1E293B",
    marginBottom: theme.spacing(1),
    "& .required": {
      color: theme.palette.error.main,
      marginLeft: theme.spacing(0.5),
    },
  },
  pointsBlock: {
    width: "100%",
    marginBottom: theme.spacing(2),
    "& .MuiTextField-root": {
      maxWidth: "120px",
      position: "relative",
      zIndex: 2,
      "& .MuiOutlinedInput-root": {
        backgroundColor: "#F8FAFC",
        borderRadius: theme.spacing(2),
        height: "60px",
        paddingRight: theme.spacing(2),
        "&:hover": {
          backgroundColor: "#F1F5F9",
        },
        "&.Mui-focused": {
          backgroundColor: "#F8FAFC",
          "& fieldset": {
            borderColor: theme.palette.primary.main,
            borderWidth: "2px",
          },
        },
        "& .MuiInputAdornment-root": {
          height: "100%",
          maxHeight: "100%",
          margin: 0,
          position: "absolute",
          right: "-32px",
          zIndex: 1,
        },
        "& input": {
          padding: "0 0 0 16px",
          width: "100%",
          textAlign: "center",
          fontSize: "32px",
          fontWeight: 600,
          color: "#1E293B",
          backgroundColor: "transparent",
          "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          "&[type=number]": {
            "-moz-appearance": "textfield",
          },
        },
      },
      "& .MuiInputLabel-root": {
        display: "none",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E2E8F0",
      },
    },
  },
  pointsIcon: {
    height: "72px",
    width: "72px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    borderRadius: `0 ${theme.spacing(2)}px ${theme.spacing(2)}px 0`,
    fontSize: "44px",
    position: "absolute",
    right: "-9px",
    top: "50%",
    transform: "translateY(-50%) rotate(20deg)",
    pointerEvents: "none",
  },
  pointsValue: {
    fontSize: "14px",
    fontWeight: 700,
    color: theme.palette.orange.main,
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
  },
  responseTypeBlock: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    backgroundColor: "#FFFFFF",
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
    marginBottom: theme.spacing(3),
  },
  infoIcon: {
    color: theme.palette.info.main,
    fontSize: "20px",
    cursor: "pointer",
  },
  requiredLabel: {
    color: theme.palette.error.main,
    marginLeft: theme.spacing(0.5),
  },
  responseTitle: {
    marginTop: theme.spacing(2),
  },
  responseTypeSelect: {
    width: "100%",
    "& .MuiInput-root": {
      backgroundColor: "#F8FAFC",
      borderRadius: theme.spacing(1.5),
      border: "1px solid #E2E8F0",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    },
    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-root.Mui-focused": {
      borderColor: theme.palette.primary.main,
      boxShadow: "0 0 0 3px rgba(35, 44, 72, 0.12)",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#F8FAFC",
      borderRadius: theme.spacing(2),
      height: "56px",
      transition: "all 0.2s ease-in-out",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
      "&:hover": {
        backgroundColor: "#F1F5F9",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      },
      "&.Mui-focused": {
        backgroundColor: "#F8FAFC",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        "& fieldset": {
          borderColor: theme.palette.primary.main,
          borderWidth: "2px",
        },
      },
    },
    "& .MuiSelect-select": {
      padding: theme.spacing(2, 3),
      fontSize: "16px",
      fontWeight: 500,
      color: "#1E293B",
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
    "& .MuiMenuItem-root": {
      fontSize: "16px",
      fontWeight: 500,
      color: "#1E293B",
      padding: theme.spacing(1.5, 3),
      "&:hover": {
        backgroundColor: "#F1F5F9",
      },
      "&.Mui-selected": {
        backgroundColor: "#E2E8F0",
        "&:hover": {
          backgroundColor: "#CBD5E1",
        },
      },
    },
  },
  responseBlock: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: "#F8FAFC",
    borderRadius: theme.spacing(2),
    border: "1px solid #E2E8F0",
  },
  markdownEditorContainer: {
    width: "100%",
    marginBottom: "0px",
    backgroundColor: "#FFFFFF",
    borderRadius: theme.spacing(1.5),
    border: "1px solid #E2E8F0",
    overflow: "hidden",
    boxShadow: "0 1px 2px rgba(17, 24, 39, 0.04)",
    "& .w-md-editor": {
      boxShadow: "none",
      backgroundColor: "transparent",
      "--md-editor-font-family":
        'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    },
    "& .w-md-editor-area, & .w-md-editor-input, & .w-md-editor-text": {
      height: "100%",
    },
    "& .w-md-editor-text": {
      minHeight: "100%",
      boxSizing: "border-box",
      color: "#1E293B",
    },
    "& .w-md-editor-text-input, & .w-md-editor-text-pre, & .w-md-editor-text-pre > code":
    {
      fontFamily:
        'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important',
      fontWeight: "400 !important",
      fontStyle: "normal !important",
      fontVariantLigatures: "none !important",
      fontFeatureSettings: '"liga" 0, "calt" 0 !important',
      fontKerning: "none !important",
      letterSpacing: "normal !important",
      tabSize: "2 !important",
      boxSizing: "border-box",
      fontSize: "14px",
      lineHeight: "22px",
      color: "#1E293B",
      [theme.breakpoints.up("md")]: {
        fontSize: "15px",
        lineHeight: "24px",
      },
    },
    "& .w-md-editor-toolbar": {
      borderBottom: "1px solid #E2E8F0",
      backgroundColor: "#F8FAFC",
    },
    "& .w-md-editor-toolbar ul > li > button": {
      color: "#374151",
    },
    "& .w-md-editor-toolbar svg": {
      color: "#1E293B",
    },
    "& .w-md-editor-content": {
      position: "relative",
      backgroundColor: "#FFFFFF",
      display: "flex !important",
      flexDirection: "row",
      alignItems: "stretch",
      height: "100%",
    },
    "& .w-md-editor-input": {
      backgroundColor: "#F9FAFB",
      borderRight: "1px solid #E5E7EB",
      position: "relative",
      flex: "1 1 50%",
      width: "50% !important",
      minWidth: 0,
      paddingTop: 32,
      boxSizing: "border-box",
      "&::before": {
        content: "var(--md-edit-label, '\"Édition\"')",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: 28,
        display: "flex",
        alignItems: "center",
        paddingLeft: 12,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: theme.palette.primary.main,
        backgroundColor: "#EEF0F5",
        borderBottom: "1px solid #DDE1EA",
        zIndex: 2,
        pointerEvents: "none",
      },
    },
    "& .w-md-editor-preview": {
      backgroundColor: "#FFFFFF",
      position: "relative !important",
      flex: "1 1 50%",
      width: "50% !important",
      minWidth: 0,
      top: "unset !important",
      right: "unset !important",
      bottom: "unset !important",
      left: "unset !important",
      paddingTop: "32px !important",
      boxSizing: "border-box",
      overflow: "auto",
      "&::before": {
        content: "var(--md-preview-label, '\"Aperçu\"')",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: 28,
        display: "flex",
        alignItems: "center",
        paddingLeft: 12,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: "#047857",
        backgroundColor: "#ECFDF5",
        borderBottom: "1px solid #D1FAE5",
        zIndex: 2,
        pointerEvents: "none",
      },
      "& .wmde-markdown": {
        backgroundColor: "transparent",
        padding: "8px 12px",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontSize: 14,
        lineHeight: "22px",
        color: "#1E293B",
        [theme.breakpoints.up("md")]: {
          fontSize: "15px",
          lineHeight: "24px",
        },
      },
    },
    "& .w-md-editor-bar": {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      "& .w-md-editor-content": {
        flexDirection: "column",
      },
      "& .w-md-editor-input, & .w-md-editor-preview": {
        width: "100% !important",
        flex: "1 1 auto",
      },
      "& .w-md-editor-input": {
        borderRight: "none",
        borderBottom: "1px solid #E5E7EB",
      },
    },
  },
  markdownEditorHint: {
    fontSize: 12,
    color: "#64748B",
    marginTop: 6,
    marginLeft: 2,
    fontStyle: "italic",
  },
  switchBlock: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  switchRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#F8FAFC",
    borderRadius: theme.spacing(1.5),
    "& .MuiFormControlLabel-root": {
      marginRight: 0,
    },
  },
  potentiometerBlock: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  potentiometerRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#F8FAFC",
    borderRadius: theme.spacing(1.5),
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  deleteButton: {
    color: theme.palette.error.main,
    "&:hover": {
      backgroundColor: "rgba(239, 68, 68, 0.04)",
    },
  },
  infoPopover: {
    marginBottom: theme.spacing(2),
    "& .MuiTypography-root": {
      color: theme.palette.info.main,
    },
  },
  enigmaTitle: {
    fontSize: "24px",
    fontWeight: 700,
    color: "#1E293B",
    marginBottom: "2px",
    "& .required": {
      color: theme.palette.error.main,
      marginLeft: theme.spacing(0.5),
    },
  },
  whiteBlock: {
    backgroundColor: "#FFFFFF",
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3),
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    height: "auto",
  },
  // 71 : carte « Média » — hauteur mini inline de 600px inutile sur mobile
  mediaBlock: {
    [theme.breakpoints.down("sm")]: {
      minHeight: "0 !important",
      height: "auto !important",
    },
  },
  rightColumn: {
    display: "flex",
    flexDirection: "column",
    height: "auto",
    width: "100%",
    gap: theme.spacing(3),
  },
  aiGenerateButton: {
    background: "linear-gradient(135deg, #FF0080, #7928CA, #4169E1)",
    color: "white",
    textTransform: "none",
    borderRadius: "12px",
    padding: "8px 16px",
    boxShadow: "0 4px 15px rgba(124, 58, 237, 0.2)",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    backgroundSize: "200% 200%",
    animation: "gradient 5s ease infinite",
    transform: "scale(1)",
    "&:hover": {
      backgroundPosition: "right center",
      transform: "scale(1.05)",
      boxShadow: "0 6px 20px rgba(124, 58, 237, 0.3)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
    "&.Mui-focusVisible": {
      outline: "3px solid rgba(121, 40, 202, 0.45)",
      outlineOffset: 2,
    },
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none",
    },
  },
  // 58 : ligne « Texte de l'énigme » + info + bouton IA
  titleRow: {
    flexWrap: "wrap",
    gap: theme.spacing(1),
    "& > .MuiButton-root": {
      marginLeft: "auto",
    },
  },
  // 59 : rangées upload / IA / corbeille
  actionsRow: {
    flexWrap: "wrap",
    rowGap: theme.spacing(1),
  },
  // 60 : icône + texte (menu des médias, titres des dialogs IA)
  inlineGap: {
    gap: theme.spacing(1.5),
  },
  deleteIconButton: {
    transition: "filter 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      filter: "brightness(0.93)",
    },
    "&.Mui-focusVisible": {
      boxShadow: "0 0 0 3px rgba(220, 38, 38, 0.35)",
    },
  },
  aiDialogPrimary: {
    "&.Mui-disabled": {
      opacity: 0.55,
    },
    "&:hover": {
      filter: "brightness(1.08)",
    },
    "&.Mui-focusVisible": {
      outline: "3px solid rgba(121, 40, 202, 0.45)",
      outlineOffset: 2,
    },
  },
  // 68 : soulignement sous le titre « Optionnel »
  sectionHeading: {
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -8,
      left: "50%",
      transform: "translateX(-50%)",
      width: 40,
      height: 4,
      borderRadius: 2,
      backgroundColor: theme.palette.secondary.main,
    },
  },
  actionBar: {
    [theme.breakpoints.up("sm")]: {
      left: "280px !important",
    },
  },
  mainContent: {
    marginLeft: 280,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      marginTop: 0,
    },
  },
  pickerSectionTitle: {
    fontWeight: 600,
    fontSize: "14px",
    color: "#1E293B",
    marginBottom: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },
  pickerAnswerRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "480px",
    },
  },
  pickerColumnCard: {
    border: "1px solid #E2E8F0",
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    backgroundColor: "#FFFFFF",
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
  },
  pickerColumnHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  pickerCorrectChip: {
    backgroundColor: "#D1FAE5",
    color: "#065F46",
    border: "1px solid #6EE7B7",
    fontWeight: 600,
    fontSize: "13px",
  },
  pickerChipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    alignItems: "center",
  },
});

export default styles;
